<div class="form-group mb-0">
  <div class="input-group input-group-md">
    <div class="input-group-prepend">
      <rx-select
        rxMandatory
        id="countrySelect"
        class="phone__select mr-1"
        data-qa="phone-number-input-country-select"
        [ngClass]="{ 'phone__select--error': showError }"
        [label]="prefixLabel"
        [formControl]="selectedCountryControl"
        [options]="countryDropdown"
        [filter]="true"
        [filterNoResultMessage]="filterNoResultMessage"
        [placeholder]="prefixPlaceholder"
        (selectItemChange)="countryChanged()"
      />
    </div>
    <rx-input
      id="phoneNumberInput"
      type="text"
      class="phone__input"
      rxMandatory
      data-qa="phone-number-input-text"
      [label]="phoneLabel"
      [ngClass]="{ 'phone__input--error': showError }"
      [placeholder]="placeHolderForCountry"
      [formControl]="phoneNumberControl"
      [validateOnBlur]="true"
      (toggle)="phoneInputChangeFocus($event)"
    />
  </div>
  <div *ngIf="showError" class="phone__error" data-qa="phone-number-input-error">
    {{ errorMessage }}
  </div>
</div>
